import { ActionButton } from "@/react/components/Spaces/CourseSpace/AdminSummary/Engagement/QuizResults/ActionButton";
import type { QuizAttemptWithCommunityMember } from "@/react/components/Spaces/CourseSpace/AdminSummary/Engagement/QuizResults/index";
import { useProfileLinkProps } from "@circle-react/hooks/profile/useProfileLinkProps";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { Typography } from "@circle-react-uikit/Typography";

interface NameAndQuizProps {
  attempt: QuizAttemptWithCommunityMember;
  refetchAttempts: () => void;
}

export const NameAndQuiz = ({ attempt, refetchAttempts }: NameAndQuizProps) => {
  const student = attempt.community_member;
  const profileLinkProps = useProfileLinkProps({
    public_uid: student.public_uid,
  });

  return (
    <div className="flex flex-col">
      <a
        {...profileLinkProps}
        className="flex w-full items-center gap-3 truncate"
      >
        <UserImage
          src={student.avatar_url}
          name={student.name}
          size="8"
          isFullRounded
        />
        <div className="flex min-w-0 flex-col items-start truncate">
          <Typography.BodySm
            weight="font-medium truncate"
            color="text-very-dark"
          >
            {student.name}
          </Typography.BodySm>
          <Typography.BodySm weight="truncate w-full" color="text-default">
            {attempt.lesson_name}
          </Typography.BodySm>
        </div>
      </a>
      <div className="ml-10 mt-2 block md:hidden">
        <ActionButton attempt={attempt} refetchAttempts={refetchAttempts} />
      </div>
    </div>
  );
};
